<template>
  <div class="weather-info-wrapper py-8 px-8 h-full" v-if="data">
    <div class="weather-info-table h-full mx-auto flex flex-col" style="max-width:550px">
      <div class="header bg-bright-blue py-3 text-shadow-strong uppercase text-center">Weather Information</div>
      <div class="values flex flex-col flex-grow mx-8">
        <div class="group mt-4 flex-grow relative" v-for="(item,i) in data" :key="i" :class="data.length - 1 == i ? 'last':''">
          <div class="label">{{item.title}}</div>
          <div class="value text-shadow font-bold">{{item.value}}</div>
          <compass :degrees="item.valueRaw" v-if="item.title == 'Wind Direction'"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Compass from '@/components/generic/Compass.vue';

export default {
      components: {
        Compass
    },
  props: ['data'],
}
</script>

<style lang="scss">
.weather-info-wrapper{
  .header {
    font-size: 1.2rem;
    border-top-left-radius: 18px;
    border-top-right-radius: 18px;
    font-weight: 600;
  }
  .weather-info-table {
    border: 2px solid rgba(white, .6);
    border-radius: 20px;
    .group {
      .label {
        font-size: 2rem;

      }
      .value {
        font-size: 4rem;
        border-bottom: 2px solid rgba(white, .6);
      }
    &.last{
      .value {
        border-bottom: none;
      }
    }
    }
  }
}

// sm
@media (max-width: 767.98px) { 
.weather-info-wrapper{
  .header {
    font-size: 1rem;
  }
  .weather-info-table {
    .group {
      .label {
        font-size: 1.8rem;
      }
      .value {
        font-size: 3rem;
        border-bottom: 2px solid rgba(white, .6);
      }
    }
  }
}
}

</style>